let forms = require( './forms' );

let complete_booking = (function( $ ) {

	let $button;

	let observer;

	let _init = function() {
		$button = $( 'a.button.complete-booking' );

		if ( $button.length > 0 ) {
			$button.on( 'click', _complete_booking );

			_start_spinner_observer();
		}
	};

	let _start_spinner_observer = function () {
		observer = new MutationObserver( _form_mutated );

		const $forms = $( '.payment-form-wrap' );

		$forms.each(function () {
			const config  = { attributes: false, childList: true, subtree: true};

			observer.observe( this, config );
		});
	}

	let _form_mutated = function( mutationsList, observer ) {
		// Use traditional 'for loops' for IE 11
		for ( const mutation of mutationsList ) {
			if ( mutation.type === 'childList' ) {
				for ( const addedNode of mutation.addedNodes ) {
					if ( typeof addedNode.classList !== 'undefined' && addedNode.classList.contains( 'gform_ajax_spinner' ) ) {
						forms.show_spinner( $( '#donation_form' ) );
					}
				}
			}
		}

		if ( $( '.payment-form-wrap' ).find( '.gform_ajax_spinner' ) ) {
			setTimeout( function() {
				forms.hide_spinner( $( '#donation_form' ) );
			}, 2000 );
		}
	};

	let _complete_booking = function( e ) {
		forms.show_spinner( $( '#donation_form' ) );

		e.preventDefault();

		let data = {
			action: 'crate_basket_get_total',
			nonce: ScriptData.crate_basket_get_total_nonce,
		};

		$.post( ScriptData.ajaxurl, data, _get_basket_total_response );
	};

	let _get_basket_total_response = function( response ) {
		if ( response.success ) {
			$( '.vibe-pricing-field .ginput_amount' ).val( response.total ).change();
			$( '#gform_submit_button_1' ).trigger( 'click' );
		} else {
			let $form = $( '#checkboxes_form' );

			$form.addClass( 'show-notices' );
			forms.display_field_errors( $form, response.errors );

			setTimeout( function() {
				forms.hide_spinner( $( '#donation_form' ) );
			}, 1000 );
		}
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = complete_booking;